import { RefString, Collection } from "@tblabs/truffle";
import { ProductCategory } from "./ProductCategory";
import { Tab } from "./Tab";
import { Field } from "./Field";
import { Product } from "./Product";
import { BasketConfig } from "./BasketConfig";
import { Faq } from "./Faq";


export class ShopContent
{
    public Id = "Shop";
    public Logo = new RefString();
    public AboutUsText = new RefString();
    public AboutUsFaq = new Collection<Faq>();
    public ProductCategories = new Collection<ProductCategory>();
    public Products = new Collection<Product>();
    public get AvailableProducts(): Product[]
    {
        return this.Products.Items.filter(x => x.Visible.value);
    }
    public BasketOptions = new BasketConfig();
    public ContactTabs = new Collection<Tab>();
    public Contact = new Collection<Field>();
    public RentalPageContentTabs = new Collection<Tab>();
    public RentalPageContent = new Collection<Field>();
}
